<ng-container *ngIf="employeeBenefitPlan && employeeBenefitPlan.employee">
    <p class="title">
        {{ employeeBenefitPlan.employee.firstName }} is currently enrolled in
        {{ employeeBenefitPlan.benefitDivision?.name }} division. What division are you switching to?
    </p>

    <!-- Switch Division Form -->
    <form autocomplete="nope" #form="ngForm" class="app-grid">
        <!-- Current Division -->
        <mat-form-field class="columns-8 small-columns-12">
            <mat-label>Currently Enrolled in</mat-label>
            <input
                matInput
                type="text"
                name="currentDivision"
                [ngModel]="employeeBenefitPlan.benefitDivision?.name"
                #currentDivision="ngModel"
                [disabled]="true"
            />
        </mat-form-field>

        <!-- New Division -->
        <mat-form-field class="columns-8 small-columns-12">
            <mat-label appRemoveAriaOwns>Switch To</mat-label>

            <mat-select
                name="switchDivision"
                (selectionChange)="onBenefitDivisionChange()"
                [(ngModel)]="newDivision"
                #switchDivision="ngModel"
                required
            >
                <mat-option *ngFor="let division of allDivisions" [value]="division">{{ division.name }}</mat-option>
            </mat-select>
            <mat-error *ngIf="switchDivision.invalid">{{ switchDivision.errors | formErrors }}</mat-error>
        </mat-form-field>

        <!-- Effective date of change -->
        <mat-form-field class="columns-8 small-columns-12">
            <mat-label> Effective Date of Change </mat-label>
            <input
                matInput
                name="effectiveDate"
                [matDatepicker]="picker"
                #effectiveDate="ngModel"
                required
                [(ngModel)]="employeeBenefitPlan.divisionEffectiveAt"
            />
            <mat-datepicker-toggle matSuffix [for]="picker">
                <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    </form>
</ng-container>
